import { LocalStorageItem } from '@constants/index'
import { useState, useCallback, useEffect } from 'react'
import { VelvetSDK } from 'sdk'
import { UserProfile } from 'sdk/services/storage/profiles/types/profilesManager'

interface UseUserProfileProps {
  profileId: string
}

export const useUserProfile = ({ profileId }: UseUserProfileProps) => {
  const userObject = JSON.parse(localStorage.getItem(LocalStorageItem.USER_DATA) as string)
  const [profileData, setProfileData] = useState<UserProfile | null>()
  const [isLoading, setIsLoading] = useState(true)

  const fetchUserProfile = useCallback(async () => {
    if (userObject?.userID && profileId && !profileData) {
      setIsLoading(true)
      try {
        const data = await VelvetSDK.Storage.Profiles.service.getProfile(userObject.userID, profileId)
        setProfileData(data)
      } catch (error) {
        console.error('Error fetching user profile:', error)
      } finally {
        setIsLoading(false)
      }
    }
  }, [profileData, profileId, userObject.userID])

  useEffect(() => {
    fetchUserProfile()
  }, [fetchUserProfile])

  return { profileData, isLoading }
}
